import request from "../utils/request"

export const getAvailableCourses = () => request.get("/courses")

export const getCourse = courseId => request.get(`/courses/${courseId}`)
